import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QRLanding from "../pages/qr/page";
import CategoryPage from "../pages/category/page";
import VenuePage from "../pages/venue/page";
import RoutesPage from "../pages/routes/page";
import AdminPage from "../pages/admin/page";
import BusinessPage from "../pages/business/page";
import MapPage from "../pages/map/page";
import AccountPage from "../pages/account/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import PublicProfilePage from "../pages/profile/page";
import UserSearchPage from "../pages/search/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:slug",
    element: <CategoryPage />,
  },
  {
    path: "/venue/:id",
    element: <VenuePage />,
  },
  {
    path: "/routes",
    element: <RoutesPage />,
  },
  {
    path: "/admin",
    element: (
      <ProtectedRoute redirectTo="/login" allowedRoles={["admin"]}>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/business",
    element: (
      <ProtectedRoute redirectTo="/login" allowedRoles={["business", "admin"]}>
        <BusinessPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/map",
    element: <MapPage />,
  },
  {
    path: "/account",
    element: (
      <ProtectedRoute redirectTo="/login">
        <AccountPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/profile/:username",
    element: <PublicProfilePage />,
  },
  {
    path: "/search",
    element: <UserSearchPage />,
  },
  {
    path: "/qr",
    element: <QRLanding />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;